import type { FC, ReactNode } from 'react'
import type { Stat } from '@/types'

import { formatNumber } from '@/lib/format'

interface StatValueProps {
    stat: Stat
    className?: string
}

/** A figure that counts up when it scrolls into view (see useScrollMotion). */
export const StatValue: FC<StatValueProps> = ({ stat, className }): ReactNode => {
    return (
        <span className={className}>
            {stat.prefix}

            <span data-count={stat.value} data-decimals={stat.decimals ?? 0} className='tabular-nums'>
                {formatNumber(stat.value, stat.decimals)}
            </span>

            {stat.suffix}
        </span>
    )
}
